/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createBackfillSessionDatesResultFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type BackfillSessionDatesResult, type ProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /backfills/session-dates
 */
export interface SessionDatesRequestBuilder extends BaseRequestBuilder<SessionDatesRequestBuilder> {
    /**
     * BackfillSessionDates
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<BackfillSessionDatesResult>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<BackfillSessionDatesResult | undefined>;
    /**
     * BackfillSessionDates
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SessionDatesRequestBuilderUriTemplate = "{+baseurl}/backfills/session-dates";
/**
 * Metadata for all the requests in the request builder.
 */
export const SessionDatesRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: SessionDatesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createBackfillSessionDatesResultFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
